import { DateTime } from '@skyjs/date';

export default function getTokenExpirationDate(token) {
  const tokenPayLoad = safeParseJwt(token);
  if (tokenPayLoad == null || tokenPayLoad.exp == null) return;

  return new DateTime(tokenPayLoad.exp * 1000);
}

function safeParseJwt(token) {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const encodedPayload = window
      .atob(base64)
      .split('')
      .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join('');

    const jsonPayload = decodeURIComponent(encodedPayload);
    return JSON.parse(jsonPayload);
    // eslint-disable-next-line no-empty
  } catch {}
}
